import instance from '@/api/index.js'
const urlPrefix = '/v1/'
export default {
  getCategory (){
    return instance({
      method: 'get',
      url: `${urlPrefix}category/details`,
    })
  },
  // 创建周报
  createReport(params) {
    return instance({
      method: 'post',
      url: `${urlPrefix}report`,
      data: params
    })
  },
  // 获取个人周报
  getReport(params) {
    return instance(
      {
        method: 'get',
        params: params,
        url: `${urlPrefix}report/list`,
      }
    )
  },
  getReportSummary(data) {
    return instance(
      {
        method: 'post',
        data: data,
        url: `${urlPrefix}report/summary_list`,
      }
    )
  },
  getExSummary(data) {
    return instance(
      {
        method: 'post',
        data: data,
        url: `${urlPrefix}report/cn_summary_list`,
      }
    )
  },
  getExSummaryExcel(data) {
    return instance(
      {
        responseType:'blob',
        method: 'post',
        data: data,
        url: `${urlPrefix}report/cn_summary_excel`,
      }
    )
  },
  getReportSummaryExcel(data) {
    return instance(
      {
        responseType:'blob',
        method: 'post',
        data: data,
        url: `${urlPrefix}report/summary_excel`,
      }
    )
  },

  // 编辑周报
  patchReport(params, data) {
    return instance(
      {
        method: 'patch',
        params: params,
        data: data,
        url:`${urlPrefix}report`
      }
    )
  },

  // 删除周报
  deleteReport(params) {
    return instance(
      {
        method: 'delete',
        params: params,
        url: `${urlPrefix}report`,
      }
    )
  },
  // 获取所有周报
  getAdminReport(params) {
    return instance(
      {
        method: 'get',
        params: params,
        url: `${urlPrefix}report/admin_list`,
      }
    )
  },
}
